export default {"src":"/_next/static/image/public/images/ic_vm_patient_portal_white.e80680817277c2eed6a9ceaa71121d7b.svg","height":18,"width":20};